(function (global) {
  'use strict';
  const KEY = 'drkalla-hair-consultation-v1';
  const TTL = 30 * 60 * 1000;
  const clean = (value, max = 240) => String(value || '').replace(/[\r\n\u0000-\u001f]/g, ' ').trim().slice(0, max);

  function buildMessage(answers, products, labels) {
    const answerText = (name) => [answers[name]].flat().map((value) => labels[value]).filter(Boolean).join(', ') || 'Keine Angabe';
    const lines = [
      'Hallo Dr.Kalla-Team,', '', 'ich wünsche eine persönliche Beratung zu meiner Haaranalyse.', '',
      `Haarzustand: ${answerText('state')}`,
      `Farbe und Behandlung: ${answerText('treatment')}`,
      `Pflegeziel: ${answerText('goal')}`,
      `Styling: ${answerText('styling')}`, '', 'Meine ausgewählte Routine:',
    ];
    for (const product of products.slice(0, 8)) {
      const variant = product.variants?.find((entry) => entry.id === product.selected);
      const title = clean(product.title);
      if (!title) continue;
      lines.push(`- ${title}${variant?.title ? ` (${clean(variant.title)})` : ''}`);
      if (/^\/products\/[a-z0-9][a-z0-9-]*\/?$/i.test(product.url)) lines.push(product.url);
    }
    if (!products.length) lines.push('Noch keine passende Empfehlung verfügbar.');
    lines.push('', 'Meine Frage oder weitere Hinweise:', '');
    return lines.join('\n');
  }
  function readPayload(raw, now = Date.now()) {
    try {
      if (typeof raw !== 'string' || raw.length > 12000) return null;
      const value = JSON.parse(raw);
      if (value?.version !== 1 || !Number.isFinite(value.at) || value.at > now || now - value.at > TTL) return null;
      if (typeof value.body !== 'string' || !value.body.trim() || value.body.length > 10000) return null;
      return value;
    } catch { return null; }
  }
  function save(answers, products, labels) {
    try {
      global.sessionStorage.setItem(KEY, JSON.stringify({ version: 1, at: Date.now(), body: buildMessage(answers, products, labels) }));
      return true;
    } catch { return false; }
  }
  function initContact() {
    if (new URLSearchParams(global.location.search).get('beratung') !== 'haaranalyse') return;
    // This marker is absent on validation errors and successful submissions.
    const status = global.document.querySelector('[data-hair-contact-status]');
    if (!status || status.dataset.ready) return;
    status.dataset.ready = 'true';
    const form = status.closest('form');
    const body = form?.querySelector('#ContactForm-body');
    const topic = form?.querySelector('#ContactForm-topic');
    const append = form?.querySelector('[data-hair-contact-append]');
    if (!body) return;
    status.hidden = false;
    let payload;
    try {
      payload = readPayload(global.sessionStorage.getItem(KEY));
      if (!payload) global.sessionStorage.removeItem(KEY);
    } catch { payload = null; }
    if (!payload) { status.textContent = status.dataset.missing; return; }
    const apply = () => {
      if (!body.value.includes(payload.body.trim())) body.value = body.value.trim() ? `${body.value.trimEnd()}\n\n${payload.body}` : payload.body;
      if (topic && !topic.value && [...topic.options].some((option) => option.value === 'Produktberatung')) topic.value = 'Produktberatung';
      status.textContent = status.dataset.success;
      if (append) append.hidden = true;
      body.dispatchEvent(new Event('input', { bubbles: true }));
      // Keep the short-lived source for reloads; never send the form automatically.
    };
    if (!body.value.trim() || body.value.includes(payload.body.trim())) apply();
    else {
      status.textContent = status.dataset.existing;
      if (append) { append.hidden = false; append.addEventListener('click', apply, { once: true }); }
    }
  }
  global.DRKALLA_HAIR_CONTACT = { buildMessage, readPayload, save, initContact };
  if (!global.document) return;
  if (global.document.readyState === 'loading') global.document.addEventListener('DOMContentLoaded', initContact, { once: true });
  else initContact();
  global.document.addEventListener('shopify:section:load', initContact);
})(typeof window !== 'undefined' ? window : globalThis);
